import {delay} from '@yandex-delivery/utils'
import type {PaymentCard} from '@yandex-delivery/api/model/payment'
import {useTransition} from '@yandex-delivery/blocks'

import type {Props} from './BoundCardModal.types'
import {buildKey} from './utils'

type BoundCardResponse = [PaymentCard[]?, string?]

export function useBoundCardModal(props: Props) {
  const {fetchCards, fetchAgreement, fetchBoundCard, fetchBindingUrl, onClose, onSuccess, card} = props
  const [{isPending, payload, error}, startTransition] = useTransition<BoundCardResponse, unknown>(
    (): Promise<BoundCardResponse> => Promise.all([fetchCards(), fetchAgreement?.()]),
    {key: buildKey('list')},
  )
  const [cards, agreement] = payload || []
  // тупой механизм для обновление MobileDrawer, чтобы шторка подстраивалась под высоту динамического контента
  const key = (function foldAsyncState() {
    if (isPending) return 'pending'
    if (cards) return `cards-${cards.length}`
    if (error) return 'error'
    return 'initial'
  })()

  function successHandler(card: PaymentCard) {
    onSuccess?.(card)
    onClose?.()
  }

  function updateHandler() {
    // после добавления карты они прорастают не сразу, надо чуть чуть подождать
    startTransition(() => delay(1000).then(() => Promise.all([fetchCards(), agreement])))
  }

  return {
    key,
    isPending,
    error,
    cards,
    card,
    agreement,
    fetchBoundCard,
    fetchBindingUrl,
    successHandler,
    updateHandler,
  } as const
}
